import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getOrderBasicInfo } from '../../store/basicOrder/actions';
import {
  setSearchValue,
  setIsTimelineUpdated,
} from '../../store/orders/actions';
import { LifelineOrderDetails } from '../../components/lifeline/orderDetails/LifelineOrderDetails/LifelineOrderDetails';
import { LifelineOrderDetailsV1 } from '../../components/lifeline/orderDetails/LifelineOrderDetails/LifelineOrderDetailsV1';
import { DeletedOrderDetails } from '../../components/lifeline/orderDetails/LifelineOrderDetails/DeletedOrderDetails';
import { DeletedOrderDetailsV1 } from '../../components/lifeline/orderDetails/LifelineOrderDetails/DeletedOrderDetailsV1';

const OrderDetails = (props) => {
  const { isNewUI, order } = props;
  const DeletedOrdersViewNotAllowed =
    !props.showArchivedDetails && order?.archive?.is_archived;

  if (DeletedOrdersViewNotAllowed) {
    if (isNewUI) return <DeletedOrderDetailsV1 {...props} />;
    else return <DeletedOrderDetails {...props} />;
  } else {
    if (isNewUI) return <LifelineOrderDetailsV1 {...props} />;
    else return <LifelineOrderDetails {...props} />;
  }
};

const mapStateToProps = (state, ownProps) => {
  const { commentsState, basicOrderState, ordersState } = state;
  const { commentsList } = commentsState;
  const { orderInfo, isOrderShimmer, issueSubmission } = basicOrderState;
  const { mapState } = state;
  const { mapData } = mapState;
  const { isWFH, searchType, isTimelineUpdated, isNewUI, showArchivedDetails } =
    ordersState;

  const { order } = ownProps;
  const orderId = order?.order?.order_id;
  const cartId = order?.order?.cart_id;
  const userId = order?.user?.id;
  const comments =
    cartId &&
    commentsList &&
    commentsList[cartId] &&
    commentsList[cartId].length
      ? commentsList[cartId]
      : null;
  const mapInfo =
    orderId && mapData && mapData[orderId] ? mapData[orderId] : null;

  return {
    activeOrderId: orderId,
    userId,
    cartId,
    order,
    comments,
    mapInfo,
    orderInfo,
    isOrderShimmer,
    isWFH,
    isNewUI,
    searchType,
    issueSubmission,
    isTimelineUpdated: isTimelineUpdated?.[orderId],
    showArchivedDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrderBasicInfo: (data) => dispatch(getOrderBasicInfo(data)),
    setSearchValue: (data) => dispatch(setSearchValue(data)),
    setIsTimelineUpdated: (data) => dispatch(setIsTimelineUpdated(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderDetails),
);
